import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
const spine = ['VISITANTE', 'WEB', 'WHATSAPP', 'IA', 'CALIFICACIÓN', 'CRM', 'AGENDA', 'SEGUIMIENTO', 'REACTIVACIÓN'];
const satellites = ['VOICE', 'FORMULARIOS', 'APIs', 'OTROS CANALES'];
export function OriginSystem() {
  return <section id="arquitectura" className="bg-carbon py-[72px] md:py-[120px]" data-id="element-106" data-mp="2wyvb59brl6i9">
      <div className="max-w-[1100px] mx-auto px-6 md:px-20" data-id="element-107" data-mp="2j8jgp3rpivny">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-14 md:mb-16 text-center max-w-[640px] mx-auto" data-id="element-108" data-mp="2j66q627vvcza">
          <h2 className="font-display text-[30px] md:text-[44px] font-bold text-arena leading-[1.15]" data-id="element-109" data-mp="24ar3ii9mujcx">
            No construimos herramientas aisladas.
            <br data-id="element-110" data-mp="8zft2wo3nk12" />
            Construimos sistemas.
          </h2>
        </motion.div>

        {/* Main spine */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} className="flex flex-wrap items-center justify-center gap-2 md:gap-2.5 mb-10" data-id="element-111" data-mp="44a7y02iu9e1">
          {spine.map((step, idx) => <Fragment key={step} data-id="element-112" data-mp="3rf9ydcz2k3tp" data-mpi={idx}>
              <span className="font-body text-[12px] md:text-[13px] font-medium text-arena bg-arena/10 border border-arena/10 rounded-full px-3.5 py-2" data-id="element-113" data-mp="3re8kz1ukz58t">
                {step}
              </span>
              {idx < spine.length - 1 && <span className="text-arena/25 text-[13px]" data-id="element-114" data-mp="2yoi2kglx1h6w">→</span>}
            </Fragment>)}
        </motion.div>

        {/* Satellites */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} className="flex flex-wrap items-center justify-center gap-2 mb-12" data-id="element-115" data-mp="3sf0om4qmkzii">
          {satellites.map(item => <span key={item} className="font-body text-[11px] uppercase tracking-[0.08em] text-salvia border border-salvia/25 rounded-full px-3 py-1.5" data-id="element-116" data-mp="39jalge6yhx31">
              {item}
            </span>)}
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.4
      }} className="text-center font-body text-[15px] text-arena/55 max-w-[420px] mx-auto" data-id="element-117" data-mp="tpjs9h075f72">
          Cada pieza tiene una función. ORIGEN se encarga de conectarlas.
        </motion.p>
      </div>
    </section>;
}